/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { RESTService, ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Post request to path:
 * /v1/ua/sd_upload_document
 *
 * @param {any} data
 * @param {Object} headers to send
 * @param {any} callback function to call once this function has finished
 */
const postSdUploadDocumentUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/sd_upload_document`;

  RESTService.post(
    url,
    data.file,
    (success, body, header) => {
      callback(success, body, header);
    },
    'application/json',
    null,
    data.metadataHeaders
  );
};

export { postSdUploadDocumentUtil };
